import React, { useEffect, useRef } from 'react';

/**
 * Hook that alerts clicks outside of the passed ref
 */
export default function useOutsideAlerter(
  ref: React.MutableRefObject<HTMLElement | null>,
  callback: () => void
) {
  // Lyssnaren binds en gång, men anropar alltid den senaste callbacken.
  // Tidigare lästes den callback som fanns vid monteringen, så en bytt
  // callback plockades aldrig upp.
  const callbackRef = useRef(callback);
  callbackRef.current = callback;

  useEffect(() => {
    /**
     * Alert if clicked on outside of element
     */
    function handleClickOutside(event: { target: any }) {
      if (ref.current && !ref.current.contains(event.target)) {
        callbackRef.current();
      }
    }
    // Bind the event listener
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      // Unbind the event listener on clean up
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [ref]);
}
